import React, { useEffect, useState }
  from 'react';
import { Tooltip } from '@mui/material';

export default function SubscriptionCard({
  id,
  name,
  description,
  price,
  addOnList,
  type,
  selectedOption,
  handleCheckboxChange,
  selectedFromAddedOnList,
  setSelectedFromAddedOnList
}: {
  id: any,
  name: string;
  description: string;
  price: number;
  addOnList: any;
  type: string;
  selectedOption: any;
  handleCheckboxChange?: any;
  handleButtonClick?: () => void;
  selectedFromAddedOnList: any;
  setSelectedFromAddedOnList: any;
}) {
  const [finalPrice, setFinalPrice] = useState<any>()
  const [selectedAddOnCount, setSelectedAddOnCount] = useState<any>(0)

  const enhanceDescription = (html: string) => {
    if (!html) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const listItems = doc.querySelectorAll('li');

    listItems.forEach((li) => {
      const icon = document.createElement('i');

      icon.className = 'fa fa-check';
      icon.style.marginRight = '5px';
      icon.style.color = '#48af98';
      li.insertBefore(icon, li.firstChild);
    });

    const list = doc.querySelector('ul, ol');

    if (list && listItems.length > 10) {
      list.classList.add('subscription-description-two-columns');
    }

    return doc.body.innerHTML;
  };

  // Enhance the description
  description = enhanceDescription(description);

  const finalPriceFunc = () => {
    if (addOnList.length > 0) {
      let acc = Number(price)

      addOnList.forEach((addOn: any) => {
        if (selectedFromAddedOnList.includes(addOn.id)) {
          acc = acc + Number(addOn.price)
        }
        else {
          acc = acc + 0
        }
      })

      setFinalPrice(Number(acc).toFixed(2))
    }
    else {
      setFinalPrice(Number(price).toFixed(2))
    }
  }

  const specialistRecommendationText = () => {
    if (selectedAddOnCount >= 3) {
      return (
        <h4 style={{ fontFamily: "Lato", display: selectedOption === name ? "block" : "none" }}>
          ( You have selected 3 or more Add-Ons, we recommend reaching out to a{" "}
          <i>
            <u>
              <a
                href="mailto:tsanders@sw2.net,jcaveny@sw2.net"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                subscription specialist
              </a>
            </u>
          </i>{" "}
          for the best possible price. )
        </h4>
      )
    }
    else {
      return <></>
    }
  }

  useEffect(() => {
    finalPriceFunc()
  }, [selectedFromAddedOnList])

  return (
    <div className={type === 'choose' ? 'free-trial-subscription-card__custom-card' : 'free-trial-subscription-card'}>
      <div className='free-trial-subscription-card__header'>
        <div className='free-trial-subscription-card__title'>
          <input id={id} type="radio" name="plan" value={name} onChange={handleCheckboxChange} checked={selectedOption === name} />
          {name}
        </div>

        <div className='free-trial-subscription-card__price'>
          ${finalPrice}&nbsp;
          <span className='free-trial-subscription-card__price__month'>/mo</span>
        </div>
      </div>

      <div className='free-trial-subscription-card__divider' style={{ display: selectedOption === name ? "block" : "none" }}></div>

      <div
        className='free-trial-subscription-card__description'
        dangerouslySetInnerHTML={{ __html: description }}
        style={{ display: selectedOption === name ? "block" : "none" }}
      />

      {addOnList.length > 0 && type !== 'choose' && (
        <div
          className='free-trial-subscription-card__addOns'
          style={{ display: selectedOption === name ? "block" : "none" }}
        >
          <h3 style={{ fontWeight: '600' }}>Add On</h3>
          <div className='free-trial-subscription-card__divider-dashed'></div>
          {addOnList.map((addOn: any) => (
            <div
              key={addOn.id}
              className='free-trial-subscription-add-on-list'
              style={{
                opacity: addOn.is_enabled ? 1 : 0.5,
                display:
                  type === 'change' && !addOn.is_enabled ? 'none' : 'flex',
              }}
            >
              {type === 'change' && (
                <div className='free-trial-subscription-add-on-list__checkbox'>
                  <input
                    type="checkbox"
                    checked={selectedFromAddedOnList.includes(addOn.id)}
                    onChange={(event: any) => {
                      const isChecked = event.target.checked;

                      if (isChecked) {
                        setSelectedFromAddedOnList([...selectedFromAddedOnList, addOn.id])
                        setSelectedAddOnCount(selectedAddOnCount + 1)
                      } else {
                        setSelectedFromAddedOnList(selectedFromAddedOnList.filter((item: any) => item !== addOn.id))
                        setSelectedAddOnCount(selectedAddOnCount - 1)
                      }
                    }}
                    disabled={!addOn.is_enabled}
                  />
                </div>
              )}
              <div className='free-trial-subscription-add-on-list__name'>
                <div className='free-trial-subscription-add-on-list__name__title'>
                  <div className='free-trial-subscription-card__addOns-name'>
                    {addOn.name}
                  </div>
                  {addOn.as_per_project_usage && (
                    <Tooltip
                      title='This feature will incur charges based on its usage across projects. Charges will be calculated per project, based on the extent of usage of this feature.'
                      placement='top'
                      arrow
                      enterTouchDelay={0}
                    >
                      <div className='free-trial-subscription-add-on-list__name__tag'>
                        As per Project Usage
                      </div>
                    </Tooltip>
                  )}
                </div>
                <h3
                  style={{
                    fontSize: '15px',
                    padding: '0px',
                  }}
                >
                  {addOn.description}
                </h3>
              </div>
              <div className='free-trial-subscription-card__addOns-price'>
                ${addOn.price}
              </div>
            </div>
          ))}
        </div>
      )}
      {specialistRecommendationText()}
    </div>
  );
}
